"use client";

type ConfirmPopUpProps = {
    title: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    hideCancelButton?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    isConfirming?: boolean;
};

export default function ConfirmPopUp({
    title,
    message,
    confirmText = "ยืนยัน",
    cancelText = "ยกเลิก",
    hideCancelButton = false,
    onConfirm,
    onCancel,
    isConfirming = false,
}: ConfirmPopUpProps) {
    return (
        <div className="fixed inset-0 z-60 flex items-center justify-center bg-black/45 p-2 sm:p-4">
            <div className="w-full max-w-[440px] rounded-xl bg-white px-4 py-6 text-center shadow-sm sm:px-10 sm:py-8">

                <h2 className="mb-5 text-lg font-bold text-[#333333] sm:mb-6 sm:text-xl">
                    {title}
                </h2>

                <p className="mb-8 whitespace-pre-line text-sm leading-relaxed text-[#777777] sm:mb-10 sm:text-base">
                    {message}
                </p>

                <div className="flex flex-row items-center justify-center gap-4 sm:gap-6">
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={isConfirming}
                        className="min-w-[100px] cursor-pointer rounded-md bg-[#62a654] px-4 py-2 text-sm font-normal text-white transition-colors hover:bg-[#4f8a43] disabled:cursor-not-allowed disabled:opacity-70 sm:text-base"
                    >
                        {isConfirming ? "กำลังบันทึก..." : confirmText}
                    </button>

                    {!hideCancelButton ? (
                        <button
                            type="button"
                            onClick={onCancel}
                            disabled={isConfirming}
                            className="min-w-[100px] cursor-pointer rounded-md bg-[#009aeb] px-4 py-2 text-sm font-normal text-white transition-colors hover:bg-[#0082c7] disabled:cursor-not-allowed disabled:opacity-70 sm:text-base"
                        >
                            {cancelText}
                        </button>
                    ) : null}
                </div>
            </div>
        </div>
    );
}